package com.evoapps.evoshift.ui.user

import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.ui.theme.animateItemIfMotion
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import com.evoapps.evoshift.ui.util.HelpCentreButton
import com.evoapps.evoshift.ui.util.HelpPage
import androidx.compose.runtime.LaunchedEffect
import evoshift.composeapp.generated.resources.dashboard_profile
import androidx.compose.material.icons.filled.Person
import evoshift.composeapp.generated.resources.nav_availability
import com.evoapps.evoshift.ui.adaptive.CentredLazyColumn
import com.evoapps.evoshift.ui.adaptive.ContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.DashboardColumns
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.domain.model.WeeklyAvailabilityTemplate
import com.evoapps.evoshift.widgets.OnScreen
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.heightIn
import androidx.compose.material3.TextButton
import androidx.compose.ui.unit.Dp
import com.evoapps.evoshift.ui.adaptive.WideContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.adaptive.hoverLift
import evoshift.composeapp.generated.resources.view_all
import com.evoapps.evoshift.ui.util.label
import com.evoapps.evoshift.ui.util.monthName
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.CalendarMonth
import androidx.compose.material.icons.filled.Description
import androidx.compose.material.icons.filled.Lock
import androidx.compose.material3.CenterAlignedTopAppBar
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.evoapps.evoshift.domain.model.AvailabilityRequest
import com.evoapps.evoshift.domain.model.Roster
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.GoldMetallicBrush
import com.evoapps.evoshift.viewmodels.AvailabilityViewModel
import com.evoapps.evoshift.widgets.RegularCard
import com.evoapps.evoshift.widgets.StandoutCard
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.availability_active_requests
import evoshift.composeapp.generated.resources.availability_create_new_template
import evoshift.composeapp.generated.resources.availability_due_in_days
import evoshift.composeapp.generated.resources.availability_due_in_days_full
import evoshift.composeapp.generated.resources.availability_due_today
import evoshift.composeapp.generated.resources.availability_fill_button
import evoshift.composeapp.generated.resources.availability_no_requests
import evoshift.composeapp.generated.resources.availability_overdue
import evoshift.composeapp.generated.resources.availability_past_rosters
import evoshift.composeapp.generated.resources.availability_quick_templates
import evoshift.composeapp.generated.resources.availability_roster_suffix
import evoshift.composeapp.generated.resources.availability_status_open
import evoshift.composeapp.generated.resources.availability_submit_by
import kotlinx.datetime.Month
import kotlinx.datetime.TimeZone
import kotlinx.datetime.daysUntil
import kotlinx.datetime.toLocalDateTime
import org.jetbrains.compose.resources.stringResource
import com.evoapps.evoshift.domain.util.AppClock.now
import kotlin.time.Instant

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun AvailabilityScreen(
    viewModel: AvailabilityViewModel,
    onNavigateToFill: (String) -> Unit,
    onNavigateToTemplate: (templateId: String?, openNew: Boolean) -> Unit,
    onViewAllTemplates: () -> Unit,
    onNavigateToProfile: () -> Unit,
    /** Null at the employee's Availability tab (back returns home there); reached from More (owners, managers), it has (SH-110). */
    onNavigateBack: (() -> Unit)? = null,
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    // Back from the weekly-templates screen: a template made there shows in Quick Templates.
    LaunchedEffect(Unit) { viewModel.onScreenShown() }
    // SH-135: asked once, for someone working for two or more employers.
    AvailabilitySharingQuestion(viewModel = com.evoapps.evoshift.di.diViewModel())

    Scaffold(
        containerColor = Cream,
        topBar = {
            EvoTopBar(
                title = stringResource(Res.string.nav_availability),
                onBack = onNavigateBack,
                showWorkplace = true,
                actions = listOf(
                    helpAction(HelpPage.AVAILABILITY),
                    TopBarAction(stringResource(Res.string.dashboard_profile), Icons.Default.Person, onNavigateToProfile, collapsible = false)
                )
            )
        },
    ) { padding ->
        // Only before there is anything to show: a refresh keeps the lists on screen.
        if (state.isLoading && state.openRosters.isEmpty() && state.pastRosters.isEmpty()) {
            Box(Modifier.fillMaxSize().padding(padding), contentAlignment = Alignment.Center) {
                CircularProgressIndicator(color = DarkGold)
            }
        } else {
            val activeRequests: @Composable () -> Unit = {
                ActiveRequestsSection(state.openRosters, state.requests, onNavigateToFill)
            }
            val quickTemplates: @Composable () -> Unit = {
                QuickTemplatesSection(
                    templates = state.templates,
                    onTemplate = { onNavigateToTemplate(it, false) },
                    onNewTemplate = { onNavigateToTemplate(null, true) },
                    onViewAll = onViewAllTemplates
                )
            }
            val pastRosters: @Composable () -> Unit = { PastRostersSection(state.pastRosters) }
            if (LocalWindowWidthClass.current.isExpanded) {
                // SH-230: on wide windows the open months with the templates on the left and the
                // past months on the right, in a centred column, instead of narrow cards hugging
                // the left with the right half empty.
                CentredLazyColumn(
                    maxWidth = WideContentMaxWidth,
                    modifier = Modifier.padding(padding),
                    contentPadding = PaddingValues(24.dp)
                ) {
                    item("columns") {
                        DashboardColumns(
                            columns = listOf(listOf(activeRequests, quickTemplates), listOf(pastRosters)),
                            spacing = 32.dp,
                            weights = listOf(0.55f, 0.45f)
                        )
                    }
                }
            } else {
                CentredLazyColumn(
                    maxWidth = ContentMaxWidth,
                    modifier = Modifier.padding(padding),
                    contentPadding = PaddingValues(start = 16.dp, top = 16.dp, end = 16.dp, bottom = 48.dp),
                    verticalArrangement = Arrangement.spacedBy(SectionGap)
                ) {
                    item("active") { activeRequests() }
                    item("templates") { quickTemplates() }
                    item("past") { pastRosters() }
                }
            }
        }
    }
}

/** The space between the screen's sections. */
private val SectionGap = 28.dp

/** "Active requests": the months open for availability, or "no requests". */
@Composable
private fun ActiveRequestsSection(openRosters: List<Roster>, requests: Map<String, AvailabilityRequest>, onFill: (String) -> Unit) {
    Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
        SectionHeader(stringResource(Res.string.availability_active_requests))
        if (openRosters.isEmpty()) {
            Text(
                stringResource(Res.string.availability_no_requests),
                style = MaterialTheme.typography.bodyMedium,
                color = OnScreen.onSurfaceVariant
            )
        }
        openRosters.forEach { roster ->
            ActiveRosterCard(roster = roster, request = requests[roster.id], onClick = { onFill(roster.id) })
        }
    }
}

/** The width of a quick template's tile, and the space between two. */
private val TemplateTileWidth = 120.dp
private val TemplateTileGap = 12.dp

/**
 * SH-230: how many template tiles fit side by side in [width]; "View all" shows only when there
 * are more tiles ([tiles]: the templates and "Create new template") than that.
 */
fun templateTilesOverflow(tiles: Int, width: Dp): Boolean {
    val fit = ((width + TemplateTileGap) / (TemplateTileWidth + TemplateTileGap)).toInt().coerceAtLeast(1)
    return tiles > fit
}

/**
 * "Quick templates": a row of the person's week templates and "Create new template". "View all"
 * (the templates' list) only when the row holds more than fits (SH-230: it showed with nothing
 * more to see), at the end of the header, which is as wide as the row under it.
 */
@Composable
private fun QuickTemplatesSection(
    templates: List<WeeklyAvailabilityTemplate>,
    onTemplate: (String) -> Unit,
    onNewTemplate: () -> Unit,
    onViewAll: () -> Unit
) {
    BoxWithConstraints(Modifier.fillMaxWidth()) {
        val overflows = templateTilesOverflow(templates.size + 1, maxWidth)
        Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(12.dp)) {
            Row(
                modifier = Modifier.fillMaxWidth().heightIn(min = 40.dp),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                SectionHeader(stringResource(Res.string.availability_quick_templates))
                if (overflows) {
                    TextButton(onClick = onViewAll, modifier = Modifier.handCursor()) {
                        Text(stringResource(Res.string.view_all), color = OnScreen.accent, fontWeight = FontWeight.Bold)
                    }
                }
            }
            LazyRow(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(TemplateTileGap)
            ) {
                items(templates, key = { it.id }) { template ->
                    Box(Modifier.animateItemIfMotion(this)) {
                        TemplateButton(
                            icon = Icons.Default.Description,
                            label = template.name,
                            modifier = Modifier.width(TemplateTileWidth),
                            onClick = { onTemplate(template.id) }
                        )
                    }
                }
                item {
                    TemplateButton(
                        icon = Icons.Default.Add,
                        label = stringResource(Res.string.availability_create_new_template),
                        isDashed = true,
                        modifier = Modifier.width(TemplateTileWidth),
                        onClick = onNewTemplate
                    )
                }
            }
        }
    }
}

/** "Past rosters": the months already closed. */
@Composable
private fun PastRostersSection(pastRosters: List<Roster>) {
    Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
        SectionHeader(stringResource(Res.string.availability_past_rosters))
        pastRosters.forEach { roster -> PastRosterItem(roster) }
    }
}

@Composable
fun SectionHeader(title: String) {
    Text(
        text = title,
        style = MaterialTheme.typography.titleMedium,
        fontWeight = FontWeight.Bold,
        color = DeepNavy
    )
}

@Composable
fun ActiveRosterCard(roster: Roster, request: AvailabilityRequest?, onClick: () -> Unit) {
    val daysRemaining = remember(request) {
        if (request == null) null
        else {
            try {
                val now = now().toLocalDateTime(TimeZone.currentSystemDefault()).date
                val due = Instant.parse(request.dueDate)
                    .toLocalDateTime(TimeZone.currentSystemDefault()).date
                now.daysUntil(due)
            } catch (e: Exception) {
                null
            }
        }
    }

    StandoutCard(
        onClick = onClick,
        modifier = Modifier.fillMaxWidth().hoverLift()
    ) {
        Column(Modifier.padding(20.dp)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                val monthLabel =
                    monthName(roster.month)
                Text(
                    text = stringResource(
                        Res.string.availability_roster_suffix,
                        monthLabel,
                        roster.year
                    ),
                    style = MaterialTheme.typography.titleLarge,
                    fontWeight = FontWeight.Bold,
                    color = Color.White,
                    // The badge keeps its one line beside a long month (it wrapped to "OTWART / A").
                    modifier = Modifier.weight(1f, fill = false).padding(end = 8.dp)
                )
                Box(
                    modifier = Modifier
                        .clip(RoundedCornerShape(4.dp))
                        .background(Color(0xFF4CAF50))
                        .padding(horizontal = 8.dp, vertical = 2.dp)
                ) {
                    Text(
                        stringResource(Res.string.availability_status_open),
                        color = Color.White,
                        maxLines = 1,
                        softWrap = false,
                        fontSize = 10.sp,
                        fontWeight = FontWeight.Bold
                    )
                }
            }

            Spacer(Modifier.height(12.dp))

            if (request != null) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(
                        Icons.Default.CalendarMonth,
                        null,
                        tint = DarkGold,
                        modifier = Modifier.size(16.dp)
                    )
                    Spacer(Modifier.width(8.dp))
                    val dueDateFormatted = request.dueDate.substringBefore("T").replace("-", " ")
                    Text(
                        text = stringResource(Res.string.availability_submit_by, dueDateFormatted),
                        style = MaterialTheme.typography.bodySmall,
                        color = DarkGold
                    )

                    daysRemaining?.let { days ->
                        Spacer(Modifier.width(8.dp))
                        Text("•", color = DarkGold.copy(alpha = 0.5f))
                        Spacer(Modifier.width(8.dp))

                        if (days <= 3) {
                            Box(
                                modifier = Modifier
                                    .clip(RoundedCornerShape(4.dp))
                                    .background(
                                        if (days < 0) Color(0xFFE57373) else Color(
                                            0xFFFF5252
                                        )
                                    )
                                    .padding(horizontal = 6.dp, vertical = 2.dp)
                            ) {
                                Text(
                                    text = when {
                                        days < 0 -> stringResource(Res.string.availability_overdue)
                                        days == 0 -> stringResource(Res.string.availability_due_today)
                                        else -> stringResource(
                                            Res.string.availability_due_in_days,
                                            days
                                        )
                                    },
                                    color = Color.White,
                                    fontSize = 10.sp,
                                    fontWeight = FontWeight.Bold
                                )
                            }
                        } else {
                            Text(
                                text = stringResource(
                                    Res.string.availability_due_in_days_full,
                                    days
                                ),
                                style = MaterialTheme.typography.bodySmall,
                                color = DarkGold
                            )
                        }
                    }
                }

                if (!request.message.isNullOrBlank()) {
                    Spacer(Modifier.height(12.dp))
                    Text(
                        text = request.message ?: "",
                        style = MaterialTheme.typography.bodySmall,
                        color = Color.White.copy(alpha = 0.7f),
                        maxLines = 2
                    )
                }
            }

            Spacer(Modifier.height(20.dp))

            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(48.dp)
                    .clip(RoundedCornerShape(12.dp))
                    .background(GoldMetallicBrush)
                    .handCursor()
                    .clickable(onClick = onClick),
                contentAlignment = Alignment.Center
            ) {
                Text(
                    stringResource(Res.string.availability_fill_button),
                    color = DeepNavy,
                    fontWeight = FontWeight.Bold
                )
            }
        }
    }
}

@Composable
fun TemplateButton(
    icon: ImageVector,
    label: String,
    modifier: Modifier = Modifier,
    isDashed: Boolean = false,
    onClick: () -> Unit
) {
    val shape = RoundedCornerShape(12.dp)
    Box(
        modifier = modifier
            .height(100.dp)
            .clip(shape)
            .background(if (isDashed) Color.Transparent else Color.White)
            .then(
                if (isDashed) Modifier.border(1.dp, Color.Gray.copy(alpha = 0.5f), shape)
                else Modifier.border(0.5.dp, DeepNavy.copy(alpha = 0.1f), shape)
            )
            .handCursor()
            .clickable(onClick = onClick),
        contentAlignment = Alignment.Center
    ) {
        Column(horizontalAlignment = Alignment.CenterHorizontally) {
            Box(
                modifier = Modifier
                    .size(40.dp)
                    .clip(CircleShape)
                    .then(if (isDashed) Modifier.background(DarkGold) else Modifier.background(Color.Transparent)),
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    imageVector = icon,
                    contentDescription = null,
                    tint = if (isDashed) Color.White else DeepNavy,
                    modifier = Modifier.size(24.dp)
                )
            }
            Spacer(Modifier.height(8.dp))
            Text(
                text = label,
                style = MaterialTheme.typography.labelSmall,
                textAlign = TextAlign.Center,
                color = DeepNavy,
                modifier = Modifier.padding(horizontal = 4.dp),
                maxLines = 2
            )
        }
    }
}

@Composable
fun PastRosterItem(roster: Roster) {
    RegularCard {
        Row(
            modifier = Modifier.padding(16.dp).fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            val monthLabel = monthName(roster.month)
            Text(
                text = "$monthLabel ${roster.year}",
                style = MaterialTheme.typography.bodyLarge,
                fontWeight = FontWeight.Bold,
                color = DeepNavy
            )

            Row(verticalAlignment = Alignment.CenterVertically) {
                Box(
                    modifier = Modifier
                        .clip(RoundedCornerShape(4.dp))
                        .background(Color.LightGray.copy(alpha = 0.5f))
                        .padding(horizontal = 8.dp, vertical = 2.dp)
                ) {
                    Text(
                        text = roster.status.label(),
                        color = DeepNavy.copy(alpha = 0.7f),
                        fontSize = 10.sp,
                        fontWeight = FontWeight.Bold
                    )
                }
                Spacer(Modifier.width(12.dp))
                Icon(Icons.Default.Lock, null, tint = Color.Gray, modifier = Modifier.size(16.dp))
            }
        }
    }
}
